import React, { useEffect, useState, useRef } from "react";
import { ScrollArea, useToast } from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { CSVLink } from "react-csv";
import { thaiDate } from "../../util";
import constant from "../../constants";

export const ReportButtonClick = () => {
  const downloadRef = useRef(null);
  const { callApi, configs } = Context();
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getUsers = async () => {
    setLoading(true);

    const data = await callApi(
      "utils-getButtonClickCount",
      {
        roundDate: selectedRoundDate,
      },
      {
        notShowLoading: true,
      }
    );

    // data.historySale = Object.entries(data?.historySale || {})
    //   .map(([key, value]) => {
    //     return {
    //       date: key,
    //       size: value.size,
    //       income: value.income,
    //       orderCount: value.orderCount,
    //     };
    //   })
    //   .sort((a, b) => new Date(a.date) - new Date(b.date));

    // data.historyUser = Object.entries(data.historyNewUser || {})
    //   .map(([key, value]) => {
    //     return { date: key, size: value.size };
    //   })
    //   .sort((a, b) => new Date(a.date) - new Date(b.date));

    // data.totalIncome = Object.values(data?.historySale).reduce((acc, value) => {
    //   acc += value.income;
    //   return acc;
    // }, 0);

    // data.roundDateNewUser = Object.values(data.historyNewUser || {}).reduce(
    //   (acc, value) => {
    //     acc += Number(value.size);
    //     return acc;
    //   },
    //   0
    // );

    setCount(data.result);
    setLoading(false);
  };

  const handleDownload = async (type) => {
    const csvBody = [];

    csvBody.push(["buttonId", "จำนวนครั้ง"]);

    Object.entries(count).forEach(([key, value], index) =>
      csvBody.push([key, value.toLocaleString()])
    );

    setCsvFileName(`รายงานการกดปุ่ม_งวด_${selectedRoundDate}.csv`);

    setCsvData(csvBody);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานการกดปุ่ม"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
        <div className="p-3 border-b border-[#E5E7E9]">
          <p className="font-semibold ">รายงานการกดปุ่ม </p>
        </div>
        <div className="p-3 ">
          <p className="font-medium text-xs">งวด</p>
          <div>
            <select
              className="border w-full py-1 border-[#1a1b1c] rounded-lg font-semibold cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
              value={selectedRoundDate}
              onChange={(e) => setSelectedRoundDate(e.target.value)}
            >
              {configs.roundDates.map((roundDate) => (
                <option key={roundDate} value={roundDate}>
                  {roundDate}
                </option>
              ))}
            </select>
          </div>
          <div className="flex mt-3">
            <button
              disabled={loading}
              className="flex w-full items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
              onClick={() => {
                getUsers();
              }}
            >
              {loading ? (
                <Spinner className="w-3 h-3" />
              ) : (
                <MdPersonSearch className="text-white" />
              )}
              ค้นหา
            </button>
          </div>

          <div ref={downloadRef} className="hidden">
            <CSVLink
              data={csvData}
              filename={csvFileName}
              style={{ display: "none" }}
            >
              Download me
            </CSVLink>
          </div>
        </div>
      </div>

      {count && (
        <div className="relative min-w-96 bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-[#E5E7E9]">
            <p className="font-semibold ">รายงานการกดปุ่ม</p>

            <button
              disabled={!count}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={() => {
                handleDownload("orders");
              }}
            >
              {loading ? <Spinner className="w-3 h-3" /> : "ดาวโหลด"}
            </button>
          </div>
          {/* <ScrollArea className={`h-96`}> */}
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">buttonId</TableHead>
                <TableHead className="">จำนวนคลิก</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {Object.values(count).length > 0 ? (
                Object.entries(count).map(([key, value], index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="font-medium">{key}</TableCell>
                      <TableCell className="font-medium">
                        {value.toLocaleString()} ครั้ง
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell className="" colSpan="8">
                    <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                      <div>
                        <MdPersonSearch className="text-white" />
                        ไม่พบคำสั่งซื้อ
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {/* </ScrollArea> */}
        </div>
      )}
    </div>
  );
};
